import { types, actions } from './requests'
export const GETLASTSWA300DATA_TYPES = {
    ...types('GETLASTSWA300DATA'),
}
export const GETLASTSWA300DATA_ACTIONS = {
    ...actions('GETLASTSWA300DATA'),
}
